import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import './lib/i18n';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
